<app-patient-notes-filter class="flex-control flex-column" [patient_id]="patient.id"></app-patient-notes-filter>
